import type { components } from '@connected/api-client/api.generated';
import type { ZodValidator } from '@tanstack/zod-form-adapter';

import { validators } from '@connected/api-client/generated/validatorsv2.generated';
import { usePatcher } from '@connected/api-client/hooks/use-patcher';
import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';
import { useForm } from '@tanstack/react-form';
import { useQuery } from '@tanstack/react-query';
import { zodValidator } from '@tanstack/zod-form-adapter';

import { queryClient } from '@/lib/query-client';

type FormValues = {
    inspectionKind: components['schemas']['ElectricalProjectInspectionKind'] | null;
};

export function useInspectionKindForm(projectVersionId: string) {
    const { patchField } = usePatcher('/api/v2/electrical/projects/inspections/patch', {
        onSettled: () => {
            queryClient.invalidateQueries(
                elektraAppQueryOptions.project.inspection.information.inspectionsEditOptions({
                    electricalProjectVersionId: projectVersionId,
                }),
            );
        },
    }, {
        body: {
            ElectricalProjectVersionId: projectVersionId,
        },
    });

    const { data } = useQuery(elektraAppQueryOptions.project.inspection.information.inspectionsEditOptions({
        electricalProjectVersionId: projectVersionId,
    }));

    const form = useForm<FormValues, ZodValidator>({
        defaultValues: {
            inspectionKind: data?.Inspection?.InspectionKind || null,
        },
        validatorAdapter: zodValidator(),
    });

    return {
        form,
        patchField,
        validators: validators.patchElectricalProjectInspectionCommand,
    };
}
